import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import ChatMessageListSF from '../../../components/superUser/account/ChatMessageListSF'

const ChatPageUI = ({ context, account, errorList, userMessageList,
  onRefreshClick, selectedRowId,
  deleteSubmitted, deleteSuccessMsg, deleteErrorList, onDeleteClick
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_chat' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`}
    centered={!account || !userMessageList} account={account} page='chat'
  >
    {
      (!account || !userMessageList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      userMessageList &&
      <ChatMessageListSF
        context={context}
        account={account}
        userMessageList={userMessageList}
        onRefreshClick={onRefreshClick}
        selectedRowId={selectedRowId}
        deleteSubmitted={deleteSubmitted}
        deleteSuccessMsg={deleteSuccessMsg}
        deleteErrorList={deleteErrorList}
        onDeleteClick={onDeleteClick}
      />
    }
    {
      userMessageList && userMessageList.length === 0 &&
      <EmptyListUI
        context={context} className='g_m_top_200'
        createDisabledMessageLabel='No messages'
      />
    }
  </SuperUserAccountPageUI>

export default ChatPageUI
